import { ICard, IScreenPosition, InfoGraphiscContent, SECTION_PROPORTION_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import "../../../assets/css/info-graphics.scss"
import { IPrimitiveProps } from "../section/Primitive"
import InFoGraphicFigure from "./info-graphics/InFoGraphicFigure"
import Card from "../contentType/cards/Card"

/* Protopia Ecosystem component */ 
const InfoGraphiscPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const {position} = usePosition( props.primitive || {position: {}} )
    const primitive: InfoGraphiscContent = ( { ...props.primitive || {}, ...position.data } ) as InfoGraphiscContent 
        
    return !!primitive.cards.length 
        ?
        
            <div className="figure flex-centered " data-primitive-type={primitive["data-primitive-type"]}>
                <InFoGraphicFigure {...props} />                
                <div className="title">
                    { primitive.title }
                </div>
                <div className="description">
                    { primitive.description }
                </div>
            </div> 
        :
        <></> 
}
export default InfoGraphiscPrimitive
